import { render, staticRenderFns } from "./AsCoachView.vue?vue&type=template&id=83b16d64&scoped=true"
import script from "./AsCoachView.vue?vue&type=script&setup=true&lang=js"
export * from "./AsCoachView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsCoachView.vue?vue&type=style&index=0&id=83b16d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b16d64",
  null
  
)

export default component.exports